import { Card, Grid } from '@mui/material';
import { ScreenOrientationType } from '../../../../../hooks/useScreenOrientation';
import { CfDataGridCardViewDefinition } from '../../../CfDataGridProps';
import { getColumnCount } from '../../../utility/data-grid-props';

export function CfDataGridSkeletonCard<TItem>(props: {
  cardViewDefinition: CfDataGridCardViewDefinition<TItem>;
  orientation: ScreenOrientationType;
}): JSX.Element {
  const columnCount = getColumnCount(props.cardViewDefinition, props.orientation);

  return (
    <Grid item xs={12 / columnCount}>
      <Card sx={{ padding: 2 }}>
        {typeof props.cardViewDefinition?.loadingPlaceholder === 'function'
          ? props.cardViewDefinition.loadingPlaceholder(props.cardViewDefinition)
          : props.cardViewDefinition?.loadingPlaceholder || ''}
      </Card>
    </Grid>
  );
}
